module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT4.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT4.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT4.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PT4.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT4.w.2.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.2.0.0.box.284.420.1987.2237.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0002.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.3.0.0.box.152.147.2399.3010.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5.w.0.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0003.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.0.1.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.4.0.0.box.0.145.2419.2587.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0004.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.1.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.1.0.box.935.1320.685.125.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT4.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "113%",
      "text-indent": "1em",
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.1.0.box.935.1320.685.125.q.80"
    }
  }, [_vm._v("Jim Harris")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.4.2.0.box.1047.2799.468.154.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0005.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.3.0.box.850.2961.855.111.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT4.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.3.0.box.850.2961.855.51.q.90"
    }
  }, [_vm._v("PELICAN PUBLISHING COMPANY")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT4.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "text-align": "center",
      "font-variant": "small-caps",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.3.1.box.1132.3021.291.51.q.80"
    }
  }, [_vm._v("Gretna 2010")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.0.0.box.624.359.925.108.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.0.box.624.359.925.108.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Marian, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("beloved ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wife, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("putting ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("up ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("old ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("T-Rex for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("last ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("twenty-seven ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("years ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.1.0.box.249.576.415.162.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.1.0.box.249.576.415.162.q.50"
    }
  }, [_vm._v("Copyright © 2010 "), _c('br'), _vm._v("By JHI Holdings Ltd "), _c('br'), _vm._v("All rights reserved "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.2.0.box.450.1280.1273.162.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.2.0.box.450.1280.1273.162.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("word ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("“Pelican” ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("depiction ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pelican ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("trademarks ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pelican ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Publishing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Company, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Inc., ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("registered ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("U.S. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Patent ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Trademark ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Office. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.3.0.box.248.1551.436.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.3.0.box.248.1551.436.46.q.60"
    }
  }, [_vm._v("ISBN: 9781589808508")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.4.0.box.228.2049.287.104.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.4.0.box.228.2049.287.104.q.101"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "26px",
      "text-indent": "0px",
      "white-space": "pre-wrap"
    }
  }, [_vm._v("♾")]), _c('span', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5.w.2.0.0.2"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "?",
      "src": "data/content-0006.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.2.0.0.3"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.5.5.0.box.248.2147.941.154.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.5.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_lineated",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.5.0.box.248.2147.941.154.q.70"
    }
  }, [_vm._v("Printed in Singapore "), _c('br'), _vm._v("Published by Pelican Publishing Company, Inc. "), _c('br'), _vm._v("1000 Burmaster Street, Gretna, Louisiana 70053 "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5.w.2.0.0.4"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96932330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0007.vue
// module id = 54
// module chunks = 0